// MERGE CONFLICTS RESULT: ORIGINALLY CREATED IN SETTINGS
import React from 'react'
import { propTypes, withFormsy } from 'formsy-react'
import { SelectFieldWrapper, StyledSelect } from './Select.styles'
import { Wrapper, FieldName, ErrorMessage } from './FormInput.styles'

class Select extends React.Component {
  constructor (props) {
    super(props)
    this.changeValue = this.changeValue.bind(this)
  }

  changeValue (event) {
    this.props.onChange ? this.props.onChange(event) : null
    this.props.setValue(event.target.value)
  }

  getErrorMessage () {
    if (!this.props.isFormSubmitted()) return
    if (this.props.isRequired() && !this.props.getValue()) {
      return `${this.props.fieldName || 'This field'} is required`
    }
    return this.props.getErrorMessage()
  }

  renderOptions () {
    return this.props.options.map(option => {
      return (
        <option key={option.title} value={option.value}>
          {option.title}
        </option>
      )
    })
  }

  render () {
    return (
      <Wrapper className={this.props.className} {...this.props}>
        <SelectFieldWrapper
          displayStyle={this.props.displayStyle}
          fieldMargin={this.props.fieldMargin}
          disabled={this.props.disabled}
          noArrow={this.props.noArrow}
          narrow={this.props.narrow}
        >
          <FieldName
            color={this.props.fieldNameColor}
            textSize={this.props.fieldNameSize}
            fieldNameMargin={this.props.fieldNameMargin}
          >
            {this.props.fieldName}
          </FieldName>
          <StyledSelect
            name={this.props.name}
            color={this.props.inputColor}
            onChange={this.changeValue}
            type={this.props.type || 'text'}
            value={this.props.getValue() || ''}
            inputWidth={this.props.inputWidth}
            textSize={this.props.textSize}
            backgroundColor={this.props.backgroundColor}
            focusColor={this.props.focusColor}
            backgroundFocusColor={this.props.backgroundFocusColor}
            errorColor={this.props.errorColor}
            noBorder={this.props.noBorder}
            isInvalid={this.getErrorMessage() && true}
            disabled={this.props.disabled}
            opacity={this.props.inputOpacity}
            narrow={this.props.narrow}
          >
            {this.renderOptions()}
          </StyledSelect>
        </SelectFieldWrapper>
        <ErrorMessage errorColor={this.props.errorColor}>
          {this.getErrorMessage()}
        </ErrorMessage>
      </Wrapper>
    )
  }
}

export default withFormsy(Select)
